import React from 'react';
import { FaFacebookF, FaInstagram, FaTwitter, FaLinkedinIn, FaMapMarkerAlt, FaPhone, FaEnvelope, FaClock, FaTiktok } from 'react-icons/fa';
import './footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        {/* Main Footer Content */}
        <div className="footer-main">
          {/* Company Info */}
          <div className="footer-section">
            <h3 className="footer-title">Retionz Cabs</h3>
            <p className="footer-description">
              Your reliable cab service partner in Sri Lanka. We offer exceptional 
              transportation experiences with comfort, safety, and punctuality 
              for all your travel needs.
            </p>
            <div className="social-links">
              <a href="https://web.facebook.com/p/Retionz-Cabs-100088900362270/?_rdc=1&_rdr#" className="social-link" aria-label="Facebook">
                <FaFacebookF className="social-icon" />
              </a>
              {/* <a href="#" className="social-link" aria-label="Instagram">
                <FaInstagram className="social-icon" />
              </a> */}
              <a href="https://www.tiktok.com/@retionzcabs" className="social-link" aria-label="Twitter">
                <FaTiktok className="social-icon" />
              </a>
              <a href="https://www.linkedin.com/in/achala-liyanaarachchi-aaa52a38a/" className="social-link" aria-label="LinkedIn">
                <FaLinkedinIn className="social-icon" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Quick Links</h4>
            <ul className="footer-links">
              <li><a href="/">Home</a></li>
              <li><a href="/aboutus">About Us</a></li>
              <li><a href="/bookings">Bookings</a></li>
              {/* <li><a href="/ourservices">Our Services</a></li> */}
              <li><a href="/packages">Packages</a></li>
              <li><a href="/contactus">Contact Us</a></li>
            </ul>
          </div>

          {/* Services */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Our Services</h4>
            <ul className="footer-links">
              <li><a href="/airport-tour">Airport Transfers</a></li>
              <li><a href="/city-rides">City Rides</a></li>
              <li><a href="/outstation-tour">Outstation Tours</a></li>
              <li><a href="/wedding-tour">Wedding Services</a></li>
              <li><a href="/short-long-term">Short & Long Term Rentals</a></li>
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-section">
            <h4 className="footer-subtitle">Contact Information</h4>
            <div className="contact-info">
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <span>Maharagama Rd, Piliyandala 10300, Sri Lanka</span>
              </div>
      <div className="contact-item">
  <FaPhone className="contact-icon" />
  <a href="tel:+94701707707" className="contact-link">+94 70 170 7707</a>
</div>
<div className="contact-item">
  <FaEnvelope className="contact-icon" />
  <a href="mailto:info@retionzcabs.lk" className="contact-link">info@retionzcabs.lk</a>
</div>

              <div className="contact-item">
                <FaClock className="contact-icon" />
                <span>24/7 Cab Services</span>
              </div>
            </div>
          </div>
        </div>

        {/* Newsletter Subscription
        <div className="newsletter-section">
          <div className="newsletter-content">
            <h4 className="newsletter-title">Subscribe to Our Newsletter</h4>
            <p className="newsletter-description">
              Get the latest offers and travel updates
            </p>
            <div className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address"
                className="newsletter-input"
              />
              <button className="newsletter-btn">Subscribe</button>
            </div>
          </div>
        </div> */}

        {/* Footer Bottom */}
        <div className="footer-bottom-cab">
          <div className="footer-bottom-content">
            <div className="copyright">
              <p>© {new Date().getFullYear()} Retionz Cabs. All Rights Reserved. | Designed and Developed by 
                <a 
                  className="glaxmore-link" 
                  href="https://www.glaxmore.com" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  &ensp; GLAXMORE
                </a>
              </p>
            </div>
  
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;